
import React from 'react';
import UserSettings from '@/components/settings/UserSettings';

const SettingsPage = () => {
  return <UserSettings data-id="zr5njrvvc" data-path="src/pages/SettingsPage.tsx" />;
};

export default SettingsPage;